import { Home, Building, Sparkles, Plane, HelpCircle, Car, Watch, Ship, Crown, MapPin, TreePine, Waves, Mountain, Gem, Sunset, Layers, Eye } from 'lucide-react';

export const COUNTRIES = [
  "United Arab Emirates","Afghanistan","Albania","Algeria","Andorra","Angola","Argentina","Armenia","Australia",
  "Austria","Azerbaijan","Bahrain","Bangladesh","Belarus","Belgium","Bhutan","Bolivia","Bosnia and Herzegovina",
  "Brazil","Brunei","Bulgaria","Cambodia","Cameroon","Canada","Chile","China","Colombia","Costa Rica",
  "Croatia","Cuba","Cyprus","Czech Republic","Denmark","Ecuador","Egypt","Estonia","Ethiopia","Finland",
  "France","Georgia","Germany","Ghana","Greece","Hong Kong","Hungary","Iceland","India","Indonesia",
  "Iran","Iraq","Ireland","Israel","Italy","Japan","Jordan","Kazakhstan","Kenya","Kuwait","Kyrgyzstan",
  "Latvia","Lebanon","Libya","Lithuania","Luxembourg","Malaysia","Maldives","Malta","Mexico","Monaco",
  "Mongolia","Montenegro","Morocco","Myanmar","Nepal","Netherlands","New Zealand","Nigeria","North Macedonia",
  "Norway","Oman","Pakistan","Palestine","Panama","Peru","Philippines","Poland","Portugal","Qatar",
  "Romania","Russia","Saudi Arabia","Serbia","Singapore","Slovakia","Slovenia","South Africa","South Korea",
  "Spain","Sri Lanka","Sudan","Sweden","Switzerland","Syria","Taiwan","Tajikistan","Tanzania","Thailand",
  "Tunisia","Turkey","Turkmenistan","Uganda","Ukraine","United Kingdom","United States","Uruguay","Uzbekistan",
  "Venezuela","Vietnam","Yemen","Zambia","Zimbabwe"
].sort();

export const CURRENCIES = [
  { code: "AED", name: "UAE Dirham", symbol: "AED" },
  { code: "USD", name: "US Dollar", symbol: "$" },
  { code: "INR", name: "Indian Rupee", symbol: "\u20b9" },
  { code: "GBP", name: "British Pound", symbol: "\u00a3" },
  { code: "EUR", name: "Euro", symbol: "\u20ac" },
  { code: "SAR", name: "Saudi Riyal", symbol: "SAR" },
];

// UAE Options
export const GOAL_OPTIONS = [
  { value: "buy", label: "Buy Property", icon: Home, desc: "Purchase your dream home in Dubai" },
  { value: "invest", label: "Invest", icon: Building, desc: "High-yield Dubai real estate" },
  { value: "lifestyle", label: "Luxury Lifestyle", icon: Sparkles, desc: "Experience elite Dubai living" },
  { value: "relocate", label: "Relocate", icon: Plane, desc: "Move to the UAE" },
  { value: "not_decided", label: "Not Yet Decided", icon: HelpCircle, desc: "Still exploring my options" },
];
export const RISK_OPTIONS = [
  { value: "conservative", label: "Conservative", desc: "Low risk, stable returns" },
  { value: "moderate", label: "Moderate", desc: "Balanced risk & reward" },
  { value: "aggressive", label: "Aggressive", desc: "High risk, high returns" },
  { value: "not_decided", label: "Not Yet Decided", desc: "Haven't decided yet" },
];
export const TIMELINE_OPTIONS = [
  { value: "immediate", label: "Immediate" },{ value: "1_month", label: "Within 1 Month" },
  { value: "3_months", label: "3 Months" },{ value: "6_months", label: "6 Months" },
  { value: "1_year", label: "1 Year" },{ value: "not_decided", label: "Not Yet Decided" },
];
export const PROPERTY_TYPES = [
  { value: "apartment", label: "Apartment", icon: Building },{ value: "villa", label: "Villa", icon: Home },
  { value: "penthouse", label: "Penthouse", icon: Crown },{ value: "townhouse", label: "Townhouse", icon: Layers },
  { value: "duplex", label: "Duplex", icon: Building },{ value: "studio", label: "Studio", icon: Eye },
  { value: "commercial", label: "Commercial", icon: Building },{ value: "not_decided", label: "Not Yet Decided", icon: HelpCircle },
];
export const VIEW_TYPES = [
  { value: "sea_view", label: "Sea View", icon: Waves },{ value: "city_view", label: "City View", icon: Building },
  { value: "garden_view", label: "Garden View", icon: TreePine },{ value: "marina_view", label: "Marina View", icon: Ship },
  { value: "golf_view", label: "Golf View", icon: Mountain },{ value: "canal_view", label: "Canal View", icon: Waves },
  { value: "not_decided", label: "Not Yet Decided", icon: HelpCircle },
];
export const INTERIOR_STYLES = [
  { value: "modern", label: "Modern Minimal", icon: Gem },{ value: "classic", label: "Classic Luxury", icon: Crown },
  { value: "contemporary", label: "Contemporary", icon: Layers },{ value: "arabic", label: "Arabian Opulence", icon: Sunset },
  { value: "smart_home", label: "Smart Home", icon: Sparkles },{ value: "not_decided", label: "Not Yet Decided", icon: HelpCircle },
];
export const DUBAI_LOCATIONS = [
  "Downtown Dubai", "Palm Jumeirah", "Dubai Marina", "Business Bay", "Jumeirah Beach Residence",
  "Dubai Hills Estate", "Arabian Ranches", "Jumeirah Village Circle", "DIFC", "Emirates Hills",
  "Damac Hills", "Town Square", "Dubai Creek Harbour", "Bluewaters Island", "Al Barari",
  "Meydan", "Dubai South", "Mohammed Bin Rashid City",
];

// India Options
export const INDIA_GOAL_OPTIONS = [
  { value: "first_home", label: "First Home", icon: Home, desc: "Buy your dream home in India" },
  { value: "upgrade", label: "Upgrade Home", icon: Building, desc: "Move to a bigger, better home" },
  { value: "invest", label: "Smart Investment", icon: Sparkles, desc: "Build wealth through real estate" },
  { value: "family_car", label: "Family Car", icon: Car, desc: "Get the perfect family vehicle" },
  { value: "not_decided", label: "Still Exploring", icon: HelpCircle, desc: "Figuring out my goals" },
];
export const INDIA_RISK_OPTIONS = [
  { value: "conservative", label: "Safe & Steady", desc: "FDs, low-risk mutual funds" },
  { value: "moderate", label: "Balanced", desc: "SIPs + some equity" },
  { value: "aggressive", label: "High Growth", desc: "Equity-heavy, startup exposure" },
  { value: "not_decided", label: "Not Sure Yet", desc: "Need guidance" },
];
export const INDIA_TIMELINE_OPTIONS = [
  { value: "immediate", label: "Ready Now" },{ value: "6_months", label: "6 Months" },
  { value: "1_year", label: "1 Year" },{ value: "2_years", label: "2+ Years" },
  { value: "exploring", label: "Just Planning" },{ value: "not_decided", label: "Not Sure" },
];
export const INDIA_PROPERTY_TYPES = [
  { value: "apartment", label: "Apartment / Flat", icon: Building },{ value: "villa", label: "Villa / Bungalow", icon: Home },
  { value: "independent_house", label: "Independent House", icon: Home },{ value: "plot", label: "Plot / Land", icon: MapPin },
  { value: "farmhouse", label: "Farmhouse", icon: TreePine },{ value: "penthouse", label: "Penthouse", icon: Crown },
  { value: "townhouse", label: "Row House", icon: Layers },{ value: "commercial", label: "Commercial Space", icon: Building },
  { value: "not_decided", label: "Not Yet Decided", icon: HelpCircle },
];
export const INDIA_VIEW_TYPES = [
  { value: "city_view", label: "City View", icon: Building },{ value: "garden_view", label: "Garden View", icon: TreePine },
  { value: "sea_view", label: "Sea View", icon: Waves },{ value: "hill_view", label: "Hill View", icon: Mountain },
  { value: "gated_community", label: "Gated Community", icon: Crown },{ value: "park_view", label: "Park View", icon: TreePine },
  { value: "not_decided", label: "Not Yet Decided", icon: HelpCircle },
];
export const INDIA_INTERIOR_STYLES = [
  { value: "modern_minimal", label: "Modern Minimal", icon: Gem },{ value: "fully_furnished", label: "Fully Furnished", icon: Home },
  { value: "contemporary", label: "Contemporary", icon: Layers },{ value: "traditional", label: "Traditional Indian", icon: Sunset },
  { value: "smart_home", label: "Smart Home", icon: Sparkles },{ value: "vastu_compliant", label: "Vastu Compliant", icon: Crown },
  { value: "not_decided", label: "Not Yet Decided", icon: HelpCircle },
];
export const INDIA_CAR_BRANDS = [
  "Maruti Suzuki", "Hyundai", "Tata Motors", "Mahindra", "Kia", "Toyota",
  "Honda", "MG Motor", "Skoda", "Volkswagen", "BMW", "Mercedes-Benz", "Audi",
  "Jeep", "Volvo", "Lexus",
];
export const INDIA_WATCH_BRANDS = [
  "Titan", "Fastrack", "Fossil", "Casio", "Tissot", "TAG Heuer", "Seiko",
  "Omega", "Rado", "Longines", "Michael Kors", "Tommy Hilfiger",
  "Rolex", "Citizen", "Apple Watch",
];
export const INDIA_LIFESTYLE_SERVICES = [
  "Gym Membership", "Club Membership", "Domestic Help", "Cook/Chef",
  "Driver", "Personal Trainer", "Kids Tutor", "Spa Membership",
  "Co-working Space", "Travel Package",
];

export const MAX_SELECT = 4;

export const LIFESTYLE_CARS = [
  "Rolls-Royce", "Bentley", "Ferrari", "Lamborghini", "Porsche", "Mercedes-Benz",
  "BMW", "Audi", "Maserati", "Aston Martin", "McLaren", "Range Rover",
  "Bugatti", "Pagani", "Tesla", "Lexus",
];
export const LIFESTYLE_WATCHES = [
  "Rolex", "Patek Philippe", "Audemars Piguet", "Richard Mille", "Cartier",
  "Omega", "TAG Heuer", "Breitling", "Hublot", "IWC", "Jaeger-LeCoultre",
  "Vacheron Constantin", "Panerai", "Tudor",
];
export const YACHT_BRANDS = [
  "Azimut", "Benetti", "Sunseeker", "Princess", "Ferretti", "Riva",
  "Majesty Yachts", "Gulf Craft", "Heesen", "Lürssen",
];
export const CONCIERGE_SERVICES = [
  "Personal Butler", "Private Chef", "Chauffeur", "Interior Design",
  "Property Management", "Relocation Assistance", "Personal Shopper",
  "Travel Concierge", "Wellness Coach", "Security Services",
];
